export default {
  ACCOUNT_MANAGEMENT: "Account Management",
  EXPORT_ADVERTISER_LIST: "Export Advertiser list",
  USER_MANAGEMENT: "User Management",
  PLATFORM: "Platform",
  SETTINGS: "Settings",
  LOGOUT: "Logout",
  TEMPLATE_MANAGEMENT: "Template Management",
  GLOSSARY: "Glossary",
};
